import styled from 'styled-components';
import { Radio, Tooltip } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { getColor, getSize, MathEnabledTextComponent, styleVariables } from '@lib/common';
import { getAnswerStatusColorTooltip } from '@module/assignment-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var getAnswerState = function getAnswerState(isCorrect, isSelected, isManuallyAwarded) {
  if (isSelected && isCorrect) return 'correctSelected';
  if (isSelected && !isCorrect && isManuallyAwarded) return 'manuallyAwardedSelected';
  if (isSelected && !isCorrect) return 'wrongSelected';
  if (!isSelected && isCorrect) return 'missedCorrect';
  return 'neutral';
};

var StyledAnswerRadio = styled(Radio).withConfig({
  displayName: "answer-itemcomponent__StyledAnswerRadio",
  componentId: "sc-19ovnwg-0"
})(["flex:1;cursor:default;.ant-radio-wrapper{margin:0 !important;}.ant-radio{top:0 !important;}align-self:center;display:flex;align-items:center;justify-content:center;padding:12px;border-radius:", ";border-width:1px;border-style:solid;border-color:", ";background-color:", ";span.ant-radio + *{flex:1;height:auto;padding-right:0;display:flex;align-items:center;flex-wrap:nowrap;}.ant-radio-inner{width:18px;height:18px;background-color:", ";border-color:", " !important;border-style:solid;border-width:1px;}.ant-radio-checked .ant-radio-inner{border-color:", ";background-color:", ";}.ant-radio-checked .ant-radio-inner::after{background-color:", ";}"], getSize('padding8'), function (_ref) {
  var $answerState = _ref.$answerState;
  if ($answerState === 'missedCorrect') return getColor('successActive');
  if ($answerState === 'correctSelected') return getColor('successActive');
  if ($answerState === 'manuallyAwardedSelected') return styleVariables.colors.gold1;
  if ($answerState === 'wrongSelected') return getColor('errorActive');
  return '#cbd5e1';
}, function (_ref2) {
  var $answerState = _ref2.$answerState;
  if ($answerState === 'correctSelected') return getColor('successBgActive');
  if ($answerState === 'manuallyAwardedSelected') return '#FFF7E6';
  if ($answerState === 'wrongSelected') return getColor('errorBgActive');
  return 'transparent';
}, function (_ref3) {
  var $answerState = _ref3.$answerState;
  if ($answerState === 'correctSelected') return getColor('successActive');
  if ($answerState === 'manuallyAwardedSelected') return styleVariables.colors.gold1;
  if ($answerState === 'wrongSelected') return getColor('errorActive');
  return getColor('fillBgWhite');
}, function (_ref4) {
  var $answerState = _ref4.$answerState;
  if ($answerState === 'correctSelected') return getColor('successActive');
  if ($answerState === 'manuallyAwardedSelected') return styleVariables.colors.gold1;
  if ($answerState === 'wrongSelected') return getColor('errorActive');
  if ($answerState === 'missedCorrect') return getColor('successActive');
  return '#cbd5e1';
}, function (_ref5) {
  var $answerState = _ref5.$answerState;
  if ($answerState === 'correctSelected') return getColor('successActive');
  if ($answerState === 'manuallyAwardedSelected') return styleVariables.colors.gold1;
  if ($answerState === 'wrongSelected') return getColor('errorActive');
  return getColor('fillIntActive');
}, function (_ref6) {
  var $answerState = _ref6.$answerState;
  if ($answerState === 'correctSelected') return getColor('successActive');
  if ($answerState === 'manuallyAwardedSelected') return styleVariables.colors.gold1;
  if ($answerState === 'wrongSelected') return getColor('errorActive');
  return getColor('fillBgWhite');
}, function (_ref7) {
  var $answerState = _ref7.$answerState;
  if ($answerState === 'correctSelected' || $answerState === 'wrongSelected' || $answerState === 'manuallyAwardedSelected') return '#fff';
  return getColor('fillIntActive');
});
var StyledAnswerPrefix = styled.span.withConfig({
  displayName: "answer-itemcomponent__StyledAnswerPrefix",
  componentId: "sc-19ovnwg-1"
})(["font-size:", ";font-weight:700;color:#334155;margin-right:", ";white-space:nowrap;"], getSize('typo14'), getSize('padding8'));
var StyledAnswerText = styled(MathEnabledTextComponent).withConfig({
  displayName: "answer-itemcomponent__StyledAnswerText",
  componentId: "sc-19ovnwg-2"
})(["font-size:", ";font-weight:700;color:#334155;line-height:", ";flex:1;word-wrap:break-word;overflow-wrap:break-word;min-width:0;display:inline;text-decoration:", ";p{margin:0;display:inline;word-wrap:break-word;overflow-wrap:break-word;}img{max-width:100%;height:auto;display:block;}table{max-width:100%;table-layout:auto;word-wrap:break-word;}.math-container{display:inline-block;vertical-align:middle;max-width:100%;}*{max-width:100%;word-wrap:break-word;overflow-wrap:break-word;}&:hover{cursor:pointer;}"], getSize('typo14'), getSize('padding20'), function (_ref8) {
  var $isWrongSelected = _ref8.$isWrongSelected;
  return $isWrongSelected ? 'line-through' : 'none';
});
var StyledAnswerTag = styled.div.withConfig({
  displayName: "answer-itemcomponent__StyledAnswerTag",
  componentId: "sc-19ovnwg-3"
})(["display:inline-flex;align-items:center;gap:", ";font-size:", ";font-weight:600;white-space:nowrap;padding:2px ", ";border-radius:", ";margin-left:", ";flex-shrink:0;color:", ";background-color:", ";border-width:1px;border-style:solid;border-color:", ";"], getSize('padding4'), getSize('typo12'), getSize('padding8'), getSize('radiusS'), getSize('padding12'), function (_ref9) {
  var $variant = _ref9.$variant;
  if ($variant === 'wrong') return getColor('errorActive');
  if ($variant === 'manuallyAwarded') return styleVariables.colors.gold1;
  return getColor('successActive');
}, function (_ref10) {
  var $variant = _ref10.$variant;
  if ($variant === 'correct') return getColor('successBgActive');
  if ($variant === 'manuallyAwarded') return '#FFF7E6';
  if ($variant === 'wrong') return getColor('errorBgActive');
  return 'transparent';
}, function (_ref11) {
  var $variant = _ref11.$variant;
  if ($variant === 'wrong') return getColor('errorActive');
  if ($variant === 'manuallyAwarded') return styleVariables.colors.gold1;
  return getColor('successActive');
});
var StyledAnswerWrapper = styled.div.withConfig({
  displayName: "answer-itemcomponent__StyledAnswerWrapper",
  componentId: "sc-19ovnwg-4"
})(["width:100%;display:flex;"]);
export var AnswerItemComponent = function AnswerItemComponent(_ref12) {
  var key = _ref12.key,
      answerId = _ref12.answerId,
      description = _ref12.description,
      isCorrect = _ref12.isCorrect,
      isSelected = _ref12.isSelected,
      index = _ref12.index,
      _ref12$isResponderVie = _ref12.isResponderView,
      isResponderView = _ref12$isResponderVie === void 0 ? false : _ref12$isResponderVie,
      _ref12$isManuallyAwar = _ref12.isManuallyAwarded,
      isManuallyAwarded = _ref12$isManuallyAwar === void 0 ? false : _ref12$isManuallyAwar,
      colorStatusCorrect = _ref12.colorStatusCorrect,
      colorStatusIncorrect = _ref12.colorStatusIncorrect,
      colorStatusCustomGrade = _ref12.colorStatusCustomGrade;
  var answerState = getAnswerState(isCorrect, isSelected, isManuallyAwarded);
  var isWrongSelected = answerState === 'wrongSelected';
  var answerLabel = isResponderView ? 'YOUR ANSWER' : 'STUDENT ANSWER';

  var getTooltipTitle = function getTooltipTitle() {
    if (answerState === 'correctSelected') {
      return getAnswerStatusColorTooltip('correct', {
        correct: colorStatusCorrect
      });
    }

    if (answerState === 'manuallyAwardedSelected') {
      return getAnswerStatusColorTooltip('manuallyAwarded', {
        customGrade: colorStatusCustomGrade
      });
    }

    if (answerState === 'wrongSelected') {
      return getAnswerStatusColorTooltip('incorrect', {
        incorrect: colorStatusIncorrect
      });
    }

    if (answerState === 'missedCorrect') {
      return getAnswerStatusColorTooltip('correct', {
        correct: colorStatusCorrect
      });
    }

    return undefined;
  };

  var renderTag = function renderTag() {
    if (answerState === 'correctSelected') {
      return /*#__PURE__*/_jsxs(StyledAnswerTag, {
        $variant: "correct",
        children: [/*#__PURE__*/_jsx(CheckOutlined, {}), answerLabel]
      });
    }

    if (answerState === 'manuallyAwardedSelected') {
      return /*#__PURE__*/_jsxs(StyledAnswerTag, {
        $variant: "manuallyAwarded",
        children: [/*#__PURE__*/_jsx(CheckOutlined, {}), answerLabel]
      });
    }

    if (answerState === 'wrongSelected') {
      return /*#__PURE__*/_jsxs(StyledAnswerTag, {
        $variant: "wrong",
        children: [/*#__PURE__*/_jsx(CloseOutlined, {}), answerLabel]
      });
    }

    if (answerState === 'missedCorrect') {
      return /*#__PURE__*/_jsxs(StyledAnswerTag, {
        $variant: "missed",
        children: [/*#__PURE__*/_jsx(CheckOutlined, {}), "CORRECT \xB7 MISSED"]
      });
    }

    return null;
  };

  var answerContent = /*#__PURE__*/_jsx(StyledAnswerWrapper, {
    children: /*#__PURE__*/_jsxs(StyledAnswerRadio, {
      value: answerId,
      checked: isSelected,
      $answerState: answerState,
      disabled: true,
      children: [/*#__PURE__*/_jsxs(StyledAnswerPrefix, {
        children: [String.fromCharCode(65 + index), "."]
      }), /*#__PURE__*/_jsx(StyledAnswerText, {
        $isWrongSelected: isWrongSelected,
        value: description
      }), renderTag()]
    }, answerId)
  });

  var tooltipTitle = getTooltipTitle();
  return tooltipTitle ? /*#__PURE__*/_jsx(Tooltip, {
    title: tooltipTitle,
    children: answerContent
  }) : answerContent;
};